import React from "react";

interface ICardProps {
    cardHeader?: string;
    cardSize?: "sm" | "md" | "lg";
    children: React.ReactNode
}

export const VeneCard = (props: ICardProps) => {
    return (
        <div className='vene-card-container'>
            { props.cardHeader && (
                <div className='vene-card-header'>
                    {props.cardHeader}
                </div>
            )}
            <div className='vene-card-body'>
                {props.children}
            </div>
        </div>
    )
}